function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IplayCircle = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: "0.8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0003 38.3307C14.5478 38.3307 7.66699 31.4499 7.66699 22.9974C7.66699 14.5449 14.5478 7.66406 23.0003 7.66406C31.4528 7.66406 38.3337 14.5449 38.3337 22.9974C38.3337 31.4499 31.4528 38.3307 23.0003 38.3307Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0004 41.9036C12.5747 41.9036 4.09424 33.4232 4.09424 22.9975C4.09424 12.5717 12.5747 4.09131 23.0004 4.09131C33.4261 4.09131 41.9065 12.5717 41.9065 22.9975C41.9065 33.4232 33.4261 41.9036 23.0004 41.9036ZM7.66705 22.9975C7.66705 31.45 14.5479 38.3308 23.0004 38.3308C31.4529 38.3308 38.3337 31.45 38.3337 22.9975C38.3337 14.545 31.4529 7.66412 23.0004 7.66412C14.5479 7.66412 7.66705 14.545 7.66705 22.9975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7003 30.4771L29.6512 23.7688C30.1687 23.3854 30.1687 22.6188 29.6512 22.2354L20.7003 15.5271C20.0678 15.0479 19.167 15.5079 19.167 16.2938V29.7104C19.167 30.4963 20.0678 30.9563 20.7003 30.4771Z",
    fill: "white"
  }));
});